import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../hooks/hooks';
import storePersist from '../../../../../redux/storePersist';
import PageLoader from '../../../../../components/PageLoader';
import OneconfigurationsComponent from '../components/one-configurations.component';
import { selectOneConfigurationsQueryItems } from '../../../../../redux/one-configurations/selector';
import { oneConfigurations } from '../../../../../redux/one-configurations/action';



const OneConfiguration = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const queryData = useSelector(selectOneConfigurationsQueryItems)
  const librariesItems = storePersist?.get("library")?.current;
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [
    chosenOneConfigurations,
    setChosenOneConfigurations
  ] = useState<any>([{
    DomainConfigurations: {
    },

  }])
  const fetchOneQueryById = () => {
    dispatch(oneConfigurations.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configurations/one/query`, entity: 'oneConfigurations', jsonData: {
        Records: [
          {
            Id: 0
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })




  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setChosenOneConfigurations({ ...chosenOneConfigurations, [fields[0]]: value });

  }
  useEffect(
    () => {

      fetchOneQueryById()
      setIsLoading(false)

    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        const oneConfigurationQueryData = {

          Id: queryData?.result?.items?.Id || 0,


          AgenciesMenuConfigurations: {
            FavIcon: queryData?.result?.items?.WebsiteConfigurations?.AgenciesMenuConfigurations?.FavIcon,
            MenuName: queryData?.result?.items?.WebsiteConfigurations?.AgenciesMenuConfigurations?.MenuName,
            ShowAgenciesMenuInHeader: queryData?.result?.items?.WebsiteConfigurations?.AgenciesMenuConfigurations?.ShowAgenciesMenuInHeader

          },
          HeaderConfigurations: {
            ShowCommunitiesMenu: queryData?.result?.items?.WebsiteConfigurations?.HeaderConfigurations?.ShowCommunitiesMenu,
            ShowEventsMenu: queryData?.result?.items?.WebsiteConfigurations?.HeaderConfigurations?.ShowEventsMenu,
            ShowProgramsMenu: queryData?.result?.items?.WebsiteConfigurations?.HeaderConfigurations?.ShowProgramsMenu,
            ShowSupportMenu: queryData?.result?.items?.WebsiteConfigurations?.HeaderConfigurations?.ShowSupportMenu

          },
          MarketplaceMenuConfigurations: {
            FavIcon: queryData?.result?.items?.WebsiteConfigurations?.MarketplaceMenuConfigurations?.FavIcon,
            MarketplaceUrl: queryData?.result?.items?.WebsiteConfigurations?.MarketplaceMenuConfigurations?.MarketplaceUrl,
            MenuName: queryData?.result?.items?.WebsiteConfigurations?.MarketplaceMenuConfigurations?.MenuName,
            ShowMarketplaceMenuInHeader: queryData?.result?.items?.WebsiteConfigurations?.MarketplaceMenuConfigurations?.ShowMarketplaceMenuInHeader,

          },
          VenturesMenuConfigurations: {
            FavIcon: queryData?.result?.items?.WebsiteConfigurations?.VenturesMenuConfigurations?.FavIcon,
            MenuName: queryData?.result?.items?.WebsiteConfigurations?.VenturesMenuConfigurations?.MenuName,
            ShowVenturesMenuInHeader: queryData?.result?.items?.WebsiteConfigurations?.VenturesMenuConfigurations?.ShowVenturesMenuInHeader

          },
          PartnerMenuConfigurations: {
            FavIcon: queryData?.result?.items?.WebsiteConfigurations?.PartnerMenuConfigurations?.FavIcon,
            MenuName: queryData?.result?.items?.WebsiteConfigurations?.PartnerMenuConfigurations?.MenuName,
            ShowPartnerMenuInHeader: queryData?.result?.items?.WebsiteConfigurations?.PartnerMenuConfigurations?.ShowPartnerMenuInHeader
          },

          CatalystMenuConfigurations: {
            ShowCatalystMenu: queryData?.result?.items?.WebsiteConfigurations?.CatalystMenuConfigurations?.ShowCatalystMenu,
            MenuName: queryData?.result?.items?.WebsiteConfigurations?.CatalystMenuConfigurations?.MenuName,
            FavIcon: queryData?.result?.items?.WebsiteConfigurations?.CatalystMenuConfigurations?.FavIcon,
            MentorMenuConfigurations: {
              ShowMentorMenu: queryData?.result?.items?.WebsiteConfigurations?.CatalystMenuConfigurations?.MentorMenuConfigurations?.ShowMentorMenu,
              MenuName: queryData?.result?.items?.WebsiteConfigurations?.CatalystMenuConfigurations?.MentorMenuConfigurations?.MenuName,
              FavIcon: queryData?.result?.items?.WebsiteConfigurations?.CatalystMenuConfigurations?.MentorMenuConfigurations?.FavIcon,
            },
            TrainerMenuConfigurations: {
              ShowTrainerMenu: queryData?.result?.items?.WebsiteConfigurations?.CatalystMenuConfigurations?.TrainerMenuConfigurations?.ShowTrainerMenu,
              MenuName: queryData?.result?.items?.WebsiteConfigurations?.CatalystMenuConfigurations?.TrainerMenuConfigurations?.MenuName,
              FavIcon: queryData?.result?.items?.WebsiteConfigurations?.CatalystMenuConfigurations?.TrainerMenuConfigurations?.FavIcon,
            },
            CorporateMenuConfigurations: {
              ShowCorporateMenu: queryData?.result?.items?.WebsiteConfigurations?.CatalystMenuConfigurations?.CorporateMenuConfigurations?.ShowCorporateMenu,
              MenuName: queryData?.result?.items?.WebsiteConfigurations?.CatalystMenuConfigurations?.CorporateMenuConfigurations?.MenuName,
              FavIcon: queryData?.result?.items?.WebsiteConfigurations?.CatalystMenuConfigurations?.CorporateMenuConfigurations?.FavIcon,
            }
          },
          CloudPageMenuConfigurations: {
            ShowCloudPageMenu: queryData?.result?.items?.WebsiteConfigurations?.CloudPageMenuConfigurations?.ShowCloudPageMenu,
            MenuName: queryData?.result?.items?.WebsiteConfigurations?.CloudPageMenuConfigurations?.MenuName,
            FavIcon: queryData?.result?.items?.WebsiteConfigurations?.CloudPageMenuConfigurations?.FavIcon,
          },
          FrameworkPageMenuConfigurations: {
            ShowFrameworkPageMenu: queryData?.result?.items?.WebsiteConfigurations?.FrameworkPageMenuConfigurations?.ShowFrameworkPageMenu,
            MenuName: queryData?.result?.items?.WebsiteConfigurations?.FrameworkPageMenuConfigurations?.MenuName,
            FavIcon: queryData?.result?.items?.WebsiteConfigurations?.FrameworkPageMenuConfigurations?.FavIcon,
          },
          NetworkPageMenuConfigurations: {
            ShowNetworkPageMenu: queryData?.result?.items?.WebsiteConfigurations?.NetworkPageMenuConfigurations?.ShowNetworkPageMenu,
            MenuName: queryData?.result?.items?.WebsiteConfigurations?.NetworkPageMenuConfigurations?.MenuName,
            FavIcon: queryData?.result?.items?.WebsiteConfigurations?.NetworkPageMenuConfigurations?.FavIcon,
          },
          TestimonialPageMenuConfigurations: {
            ShowTestimonialPageMenu: queryData?.result?.items?.WebsiteConfigurations?.TestimonialPageMenuConfigurations?.ShowTestimonialPageMenu,
            MenuName: queryData?.result?.items?.WebsiteConfigurations?.TestimonialPageMenuConfigurations?.MenuName,
            FavIcon: queryData?.result?.items?.WebsiteConfigurations?.TestimonialPageMenuConfigurations?.FavIcon,
          },
          MembershipMenuConfigurations: {
            ShowMembershipMenuInHeader: queryData?.result?.items?.WebsiteConfigurations?.MembershipMenuConfigurations?.ShowMembershipMenuInHeader,
            MenuName: queryData?.result?.items?.WebsiteConfigurations?.MembershipMenuConfigurations?.MenuName,
            FavIcon: queryData?.result?.items?.WebsiteConfigurations?.MembershipMenuConfigurations?.FavIcon,
          },

        }
        setChosenOneConfigurations(oneConfigurationQueryData)

      }
    },
    [isQuery]
  )


  const handleFormSubmit = async (event: any) => {
    event.preventDefault();


    await dispatch(oneConfigurations.resetAction({ actionType: 'update' }))
    await dispatch(oneConfigurations.update({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configurations/one`, entity: 'oneConfigurations', jsonData: {

        Records: [
          {
            Id: chosenOneConfigurations?.Id,
            WebsiteConfigurations:
            {
              AgenciesMenuConfigurations: {
                FavIcon: chosenOneConfigurations?.AgenciesMenuConfigurations?.FavIcon || '',
                MenuName: chosenOneConfigurations?.AgenciesMenuConfigurations?.MenuName || '',
                ShowAgenciesMenuInHeader: chosenOneConfigurations?.AgenciesMenuConfigurations?.ShowAgenciesMenuInHeader || false,

              },
              HeaderConfigurations: {
                ShowCommunitiesMenu: chosenOneConfigurations?.HeaderConfigurations?.ShowCommunitiesMenu || false,
                ShowEventsMenu: chosenOneConfigurations?.HeaderConfigurations?.ShowEventsMenu || false,
                ShowProgramsMenu: chosenOneConfigurations?.HeaderConfigurations?.ShowProgramsMenu || false,
                ShowSupportMenu: chosenOneConfigurations?.HeaderConfigurations?.ShowSupportMenu || false,

              },
              MarketplaceMenuConfigurations: {
                FavIcon: chosenOneConfigurations?.MarketplaceMenuConfigurations?.FavIcon || '',
                MarketplaceUrl: chosenOneConfigurations?.MarketplaceMenuConfigurations?.MarketplaceUrl || '',
                MenuName: chosenOneConfigurations?.MarketplaceMenuConfigurations?.MenuName || '',
                ShowMarketplaceMenuInHeader: chosenOneConfigurations?.MarketplaceMenuConfigurations?.ShowMarketplaceMenuInHeader || false,

              },
              VenturesMenuConfigurations: {
                FavIcon: chosenOneConfigurations?.VenturesMenuConfigurations?.FavIcon || '',
                MenuName: chosenOneConfigurations?.VenturesMenuConfigurations?.MenuName || '',
                ShowVenturesMenuInHeader: chosenOneConfigurations?.VenturesMenuConfigurations?.ShowVenturesMenuInHeader || false,

              },
              PartnerMenuConfigurations: {
                FavIcon: chosenOneConfigurations?.PartnerMenuConfigurations?.FavIcon || '',
                MenuName: chosenOneConfigurations?.PartnerMenuConfigurations?.MenuName || '',
                ShowPartnerMenuInHeader: chosenOneConfigurations?.PartnerMenuConfigurations?.ShowPartnerMenuInHeader || false,
              },
              CatalystMenuConfigurations: {
                ShowCatalystMenu: chosenOneConfigurations?.CatalystMenuConfigurations?.ShowCatalystMenu || false,
                MenuName: chosenOneConfigurations?.CatalystMenuConfigurations?.MenuName || '',
                FavIcon: chosenOneConfigurations?.CatalystMenuConfigurations?.FavIcon || '',

                MentorMenuConfigurations: {
                  ShowMentorMenu: chosenOneConfigurations?.CatalystMenuConfigurations?.MentorMenuConfigurations?.ShowMentorMenu || false,
                  MenuName: chosenOneConfigurations?.CatalystMenuConfigurations?.MentorMenuConfigurations?.MenuName || '',
                  FavIcon: chosenOneConfigurations?.CatalystMenuConfigurations?.MentorMenuConfigurations?.FavIcon || '',
                },
                TrainerMenuConfigurations: {
                  ShowTrainerMenu: chosenOneConfigurations?.CatalystMenuConfigurations?.TrainerMenuConfigurations?.ShowTrainerMenu || false,
                  MenuName: chosenOneConfigurations?.CatalystMenuConfigurations?.TrainerMenuConfigurations?.MenuName || '',
                  FavIcon: chosenOneConfigurations?.CatalystMenuConfigurations?.TrainerMenuConfigurations?.FavIcon || '',
                },
                CorporateMenuConfigurations: {
                  ShowCorporateMenu: chosenOneConfigurations?.CatalystMenuConfigurations?.CorporateMenuConfigurations?.ShowCorporateMenu || false,
                  MenuName: chosenOneConfigurations?.CatalystMenuConfigurations?.CorporateMenuConfigurations?.MenuName || '',
                  FavIcon: chosenOneConfigurations?.CatalystMenuConfigurations?.CorporateMenuConfigurations?.FavIcon || '',
                },
              },
              CloudPageMenuConfigurations: {
                ShowCloudPageMenu: chosenOneConfigurations?.CloudPageMenuConfigurations?.ShowCloudPageMenu || false,
                MenuName: chosenOneConfigurations?.CloudPageMenuConfigurations?.MenuName || '',
                FavIcon: chosenOneConfigurations?.CloudPageMenuConfigurations?.FavIcon || '',
              },
              FrameworkPageMenuConfigurations: {
                ShowFrameworkPageMenu: chosenOneConfigurations?.FrameworkPageMenuConfigurations?.ShowFrameworkPageMenu || false,
                MenuName: chosenOneConfigurations?.FrameworkPageMenuConfigurations?.MenuName || '',
                FavIcon: chosenOneConfigurations?.FrameworkPageMenuConfigurations?.FavIcon || '',
              },
              NetworkPageMenuConfigurations: {
                ShowNetworkPageMenu: chosenOneConfigurations?.NetworkPageMenuConfigurations?.ShowNetworkPageMenu || false,
                MenuName: chosenOneConfigurations?.NetworkPageMenuConfigurations?.MenuName || '',
                FavIcon: chosenOneConfigurations?.NetworkPageMenuConfigurations?.FavIcon || '',
              },
              TestimonialPageMenuConfigurations: {
                ShowTestimonialPageMenu: chosenOneConfigurations?.TestimonialPageMenuConfigurations?.ShowTestimonialPageMenu || false,
                MenuName: chosenOneConfigurations?.TestimonialPageMenuConfigurations?.MenuName || '',
                FavIcon: chosenOneConfigurations?.TestimonialPageMenuConfigurations?.FavIcon || '',
              },
              MembershipMenuConfigurations: {
                ShowMembershipMenuInHeader: chosenOneConfigurations?.MembershipMenuConfigurations?.ShowMembershipMenuInHeader || false,
                MenuName: chosenOneConfigurations?.MembershipMenuConfigurations?.MenuName || '',
                FavIcon: chosenOneConfigurations?.MembershipMenuConfigurations?.FavIcon || '',
              },

            }
          }
        ]

      }
    }))
      .then(() => {
        back()
      })
  }

  const back = () => {
    navigate('/management/configuration/one-configurations')
  }
  return (
    <>

      {isLoading ? <PageLoader /> :
        <OneconfigurationsComponent
          periods={librariesItems?.MessageDelayPeriod}
          handleInnerFormChange={handleInnerFormChange}
          chosenOneConfigurations={chosenOneConfigurations}
          back={back}
          handleFormSubmit={handleFormSubmit}

        />
      }
    </>
  )

}

export default OneConfiguration;